<ng-container *ngIf="dataUrl$ | async as url; else imageLoader">
    <img class="{{class}}" [src]="url" alt=""/>
</ng-container>
<ng-template #imageLoader>
    <div class="image-loader">
        <mat-spinner mode="indeterminate" [diameter]="20"></mat-spinner>
    </div>
</ng-template>
